import { defaultConfig, plugin } from '@formkit/vue'
import { all } from '@vee-validate/rules'
import { defineRule } from 'vee-validate'
import { createApp } from 'vue'

import App from './App.vue'
import ErrorPage from './ErrorPage.vue'

// Vee validate rules
// Source: https://vee-validate.logaretm.com/v4/guide/global-validators/#vee-validaterules
Object.entries(all).forEach(([name, rule]) => {
  defineRule(name, rule)
})

const app = createApp({ ...App })

app.config.errorHandler = (err, vm, info) => {
  console.error('Global Error:', err)
  console.error('Info:', info)
  // Can handle the error globally here (e.g. show a notification ?)
}

import { i18n } from '@/lang/setup'
app.use(i18n)

import store from './store'
app.use(store)

import appRouter from './router'
app.use(appRouter)

import { createPinia } from 'pinia'
const pinia = createPinia()
app.use(pinia)

// Vuetify
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { VDateInput } from 'vuetify/labs/VDateInput'
import { VNumberInput } from 'vuetify/labs/VNumberInput'
import { VTimePicker } from 'vuetify/labs/VTimePicker'

const labComponents = { VNumberInput, VTimePicker, VDateInput }

const vuetify = createVuetify({
  components: { ...components, ...labComponents },
  directives,
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: brelagLightTheme['colors'],
      },
    },
  },
})
app.use(vuetify)

import VuetifyUseDialog from 'vuetify-use-dialog'
app.use(VuetifyUseDialog)

app.use(plugin, defaultConfig({}))

import { LicenseManager } from 'ag-grid-enterprise'
LicenseManager.setLicenseKey(
  // Previous Key (old, expired key)    expiry_date = 28. October 2022
  //'CompanyName=Brelag Schweiz AG,LicensedApplication=Knockaut_Styler,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=1,AssetReference=AG-021666,ExpiryDate=28_October_2022_[v2]_MTY2NjkxMTYwMDAwMA==35d50f8a7c774882f37f85b2b11be666'
  // Current In-Use key  (new key)      expiry_date = 28. October 2024
  'Using_this_AG_Grid_Enterprise_key_( AG-048510 )_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_( legal@ag-grid.com )___For_help_with_changing_this_key_please_contact_( info@ag-grid.com )___( Brelag Schweiz AG )_is_granted_a_( Single Application )_Developer_License_for_the_application_( Knockaut_Styler )_only_for_( 1 )_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_( Knockaut_Styler )_need_to_be_licensed___( Knockaut_Styler )_has_been_granted_a_Deployment_License_Add-on_for_( 1 )_Production_Environment___This_key_works_with_AG_Grid_Enterprise_versions_released_before_( 28 October 2024 )____[v2]_MTczMDA3MzYwMDAwMA==067bbfb212ebab6196ccd3f200d133f9'
)

await store
  .dispatch('global/initialize', { router: appRouter, app: app })
  .catch(() => {
    console.log('global/initialize failed')
    // If we land here, the server is not responding. It's either offline or rejecting our request
    // for some reason (e.g. requires VPN connection). Simply show an error page.
    createApp({
      ...ErrorPage,
    })
  })

import { FloorPlanEditor } from '@/apps/brelag/mandator-user/project-editor/floorPlanEditor'
import { KnockautHandler } from '@/apps/brelag/mandator-user/project-editor/knockaut/knockautHandler'
import { ProjectEditor } from '@/apps/brelag/mandator-user/project-editor/projectEditor'

import { brelagLightTheme } from './vuetify/theme/BrelagTheme'

FloorPlanEditor.getInstance(store)
ProjectEditor.getInstance(store)
KnockautHandler.getInstance()

app.mount('#app')

import { AppInsightHandler } from '@/api/AppInsightHandler'
import { formatDate, formatSize } from '@/util/filters'

app.use(AppInsightHandler, {
  connectionString: 'InstrumentationKey=27eaa270-8b89-4113-93da-db56a4e89bad;IngestionEndpoint=https://switzerlandnorth-0.in.applicationinsights.azure.com/;LiveEndpoint=https://switzerlandnorth.livediagnostics.monitor.azure.com/;ApplicationId=3ff5c4ae-c84e-4370-a106-a4af8dddfa9a',
})

app.config.globalProperties.$filters = {
  formatSize,
  formatDate,
}
import L from 'leaflet'

// declare let require: any
// L.Icon.Default.mergeOptions({
//   iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
//   iconUrl: require('leaflet/dist/images/marker-icon.png'),
//   shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
// })
